/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	DataRemovalRequestApprovePathParams,
	DataRemovalRequestApproveResponse,
} from '../types/DataRemovalRequestApprove'

/**
 * POST /organisations/:organisation/data-removal-requests/:dataRemovalRequest/approve
 * @see backend/nexus/modules/Campaign/Http/Controllers/DataRemovalRequestController.php DataRemovalRequestController::approve
 */
export async function dataRemovalRequestApprove(
	organisation: DataRemovalRequestApprovePathParams['organisation'],
	dataRemovalRequest: DataRemovalRequestApprovePathParams['dataRemovalRequest'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<DataRemovalRequestApproveResponse>> {
	return axiosInstance.post(
		`/organisations/${organisation}/data-removal-requests/${dataRemovalRequest}/approve`,
		undefined,
		config,
	)
}
